import { Link } from "react-router-dom";
import { categories } from "@/mocks/movies";

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-10">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-900/60 border border-background-800/50 hover:border-primary-500/30 hover:bg-background-800/60 transition-all duration-300 cursor-pointer"
          >
            <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-500/10 text-primary-400 group-hover:bg-primary-500/20 group-hover:text-primary-300 transition-all duration-300">
              <i className={`${cat.icon} text-2xl`}></i>
            </div>
            <span className="text-sm md:text-base font-semibold text-foreground-200 group-hover:text-foreground-50 transition-colors">
              {cat.name}
            </span>
            <span className="text-xs text-foreground-500 group-hover:text-foreground-400 transition-colors">
              海量资源
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}